import { ColumnLayout, ColumnCount } from 'components/Shared/Layout/columnLayout';
import { Category } from 'components/Categories';
import CategoryLinks from './CategoryLinks';
import styles from './styles.scss';
import { take } from 'utils';
import connect from 'components/Shared/connect';

interface OwnProps {
  categories: Category[];
}

const sliceCategories = (categories: Category[]): Category[] => {
  const CATEGORIES_PER_ROW = 4;
  if (categories.length <= CATEGORIES_PER_ROW) {
    return categories;
  }
  const evenNumberOfCategories = categories.length - (categories.length % CATEGORIES_PER_ROW);
  return take(categories, evenNumberOfCategories);
};

const Categories = ({ categories }: OwnProps) => {
  return (
    <ColumnLayout className={styles.categoryLinks} columns={ColumnCount.Four}>
      {categories.map((category, i) => (
        <CategoryLinks
          title={category.title}
          image={category.image}
          categoryUrl={category.url}
          key={`${category.id}${i}`}
          id={category.id}
        />
      ))}
    </ColumnLayout>
  );
};

export default connect<OwnProps, OwnProps>(undefined, undefined, (_state, _dispatch, props) => ({
  ...props,
  categories: sliceCategories(props.categories)
}))(Categories);
